import React from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import { getHash } from './hash';
import { encodeUriParam } from 'utils';

const createHashtagLink = (index, match) => {
  const [origTag, hashSymbol, tagName] = match;
  const key = getHash(origTag + index);

  return (
    <Link key={key} to={`/search/${encodeUriParam(tagName)}`}>
      {`${hashSymbol}${tagName}`}
    </Link>
  );
};

const convertUrlIntoATag = (index, match) => {
  const [url, ,] = match;
  const key = getHash(url + index);

  return (
    <a href={url} key={key} rel="noopener noreferrer" target="_blank">
      {url}
    </a>
  );
};

const convertATagIntoATag = (index, match) => {
  const [, href, label] = match;
  const key = getHash(href + index);

  return (
    <a href={href} key={key} rel="noopener noreferrer" target="_blank">
      {label}
    </a>
  );
};

const createComponents = (childIndex, text, option) => {
  if (isEmpty(text)) {
    return [];
  }
  const pattern = option.pattern;
  const result = pattern.exec(text);
  if (result) {
    const index = result.index;
    const [match] = result;

    return [text.substring(0, index), option.createComponent(childIndex, result), text.substring(index + match.length)];
  }
  return [text];
};

const config = [
  {
    pattern: /<a href="([^\\'\\"]+)[^>]+>([^<]+)<\/a>/,
    createComponent: convertATagIntoATag,
  },
  {
    pattern:
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s|"]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s|"]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s|"]{2,}|www\.[a-zA-Z0-9]+\.[^\s|"]{2,})/,
    createComponent: convertUrlIntoATag,
  },
  {
    pattern: /(#)([a-zA-Z]{2,})/,
    createComponent: createHashtagLink,
  },
];

export const textToLinks = (text) => {
  if (typeof text !== 'string' || isEmpty(text)) {
    return null;
  }

  let chunks = [text];
  let childIndex = 0;

  config.forEach((option) => {
    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      if (typeof chunk === 'string') {
        const components = createComponents(childIndex, chunk, option);
        childIndex++;
        chunks.splice(i, 1, ...components);
      }
    }
  });

  return chunks;
};
